import { MailCheck } from 'lucide-react';
import { Card } from '@/shared/ui/card';

interface PublicInviteGiftEmailedProps {
  email: string;
}

/**
 * Equivalente a views/invite_resend_trintaeum.ejs — resgate concluído, mas
 * SEM entrega de wallet: o cartão sempre chega só por e-mail nesse fluxo
 * (legacy/fixe-link-2 routes/invite.js `generateInviteGiftTrinta`).
 */
export function PublicInviteGiftEmailed({ email }: PublicInviteGiftEmailedProps) {
  return (
    <Card className="mx-auto max-w-md p-8 text-center">
      <MailCheck className="mx-auto size-12 text-success" />
      <h1 className="mt-4 text-xl font-semibold">Cartão resgatado!</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        Enviamos o cartão para o e-mail <b>{email}</b>.
      </p>
    </Card>
  );
}
